export default __webpack_public_path__ + "static/cr-sort-order-gif-8282b033675fec892d3013fe701e68b7.mp4";